<template>
  <section id="contact" class="py-0">
    <div class="buffer"></div>
    <div class="footer-green">
      <div class="container px-lg-0 px-4">
        <p style="font-size: 26px" class="footer-shadow f-500 mb-2">{{ $t('contact.title') }}</p>
        <div class="row">
          <p class="footer-shadow f-500 col-lg-8 mb-lg-0 mb-3">{{ $t('contact.address') }}</p>
          <div class="d-flex col-lg-4 justify-content-lg-end">
            <router-link :to="$route.params.lang ? '/' : '/en'" class="d-flex align-items-center text-uppercase lang">
              <img style="width: 40px; height: 40px" :src="getImage(locale)" alt="language">
              <p class="footer-shadow ml-3 f-500">{{ $t("contact.language") }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'footerTop',
  computed: {
    locale() {
      return this.$route.params.lang || 'th'
    }
  },
  methods: {
    getImage(lang) {
      return require('../assets/images/' + lang + '.png');
    }
  }
}
</script>

<style lang="sass" scoped>
  .buffer
    padding-top: 30rem
    width: 100%
    @media (max-width: 792px) 
      padding-top: 5rem

  .footer-green
    background: transparent linear-gradient(180deg, #7FEBC5 0%, #40C1AC 100%) 0% 0% no-repeat padding-box
    color: #fff
    height: 165px
    display: flex
    align-items: center

  .footer-shadow
    text-shadow: 0px 3px 6px #00000029

  .lang
    cursor: pointer
    color: #fff !important
  
  .lang:hover > p
    color: blue
</style>


// WEBPACK FOOTER //
// src/components/footer_top.vue